import { createFileRoute } from '@tanstack/react-router'
import BarcodeStickerScreen from '@/components/barcode'

export const Route = createFileRoute('/barcode/')({
  component: BarcodeStickerScreen,
  validateSearch: (search: Record<string, unknown>) => {
    return {
      itemsJson: typeof search.itemsJson === 'string' ? search.itemsJson : undefined
    };
  }
})